/**
 * The units work is measured in.
 *
 * One list, used by both the job form (what work is planned) and the
 * consumption form (what a rate is measured against). They have to agree: a
 * rate of sacks per stage is only comparable to a job whose planned work is
 * counted in stages, and the forecast discards any rate it cannot match to a
 * job's unit. When the two forms offered different vocabularies — PER_FOOT
 * against ft — nothing entered through the UI could ever be projected.
 */
export const WORK_UNITS = [
  { value: 'ft', label: 'ft — feet' },
  { value: 'm', label: 'm — metres' },
  { value: 'stage', label: 'stage — stages' },
  { value: 'hour', label: 'hour — hours' },
  { value: 'day', label: 'day — days' },
  { value: 'cycle', label: 'cycle — cycles' },
  { value: 'bbl', label: 'bbl — barrels' },
  { value: 'ton', label: 'ton — tons' },
] as const;

/**
 * The same units as a rate denominator, stored the way they read: "per stage".
 *
 * The server strips the "per " before comparing, so the stored form is free to
 * be the legible one.
 */
export const RATE_UNITS = WORK_UNITS.map((u) => ({
  value: `per ${u.value}`,
  label: `per ${u.value}`,
}));
